export default {
  quality: {
    dashboard: {
      title: "Quality dashboard",
      filters: {
        label: "Filters",
        allListing: { title: "All listing" },
        allTiers: { title: "All tiers " },
        allQuality: { title: "All" },
        searchListingID: { title: "Search by Listing ID" },
        dateRange: { title: "Date range" },
      },
      table: {
        listingID: "Listing ID",
        updateByCus: "Updated by customer",
        aging: "Aging",
        issue: "Issue",
        tier: "Tier",
        quality: "Quality",
        verified: "Verified",
      },
    },
    verificationImage: {
      title: "Image quality verification",
      button: {
        cancel: "Cancel",
        submit: "Submit",
      },
      section: {
        listingID: {
          title: "Listing ID: {id}",
          notValid:
            "You have {issueImage} of {totalImage} images with quality issue",
          valid:
            "The issues in this listing has been succesfully <span>verified</span>.",
          verifiedDate: "Date verified: {verifiedDate}",
          submit_outdated:
            "The listing is outdated, verification is not required. Please proceed to submit as outdated.",
          result_outdated:
            "This listing has been succesfully <span>verified</span> as <div>outdated</div>.",
        },
        addNote: {
          title: "Additional note",
        },
        image: {
          title: "Image {number}",
        },
        issueDetect: {
          title: "Issue detected by system ",
        },
        issueVerification: {
          title: "Please verify the issue, or select another option",
          duplicates: "Duplicates",
          email: "Email address",
          contact: "Contact number",
          illicit: "Illicit",
          unauthorised: "Unauthorised logo",
          issue: "No issue",
        },
      },
    },
    verificationAddress: {
      title: "Address verification",
      button: {
        cancel: "Cancel",
        submit: "Submit",
      },
      section: {
        listingID: {
          title: "Listing ID: {id}",
          notValid: "Address information not valid.",
          valid:
            "The address in this listing has been succesfully <span>verified</span>.",
          verifiedDate: "Date verified: {verifiedDate}",
          submit_outdated:
            "The listing is outdated, verification is not required. Please proceed to submit as outdated.",
          result_outdated:
            "This listing has been succesfully <span>verified</span> as <div>outdated</div>.",
        },
        addInfo: {
          title: "Address information",
          name: "Name",
          district: "Area-district:",
          address: "Address:",
          property: "Property type:",
          unit: "Unit/Room number/House:",
          floor: "Floor",
        },
        issueVerification: {
          title: "Please verify the issue by selecting one of the below",
          valid: "Valid",
          invali: "Invalid",
          unverified: "Unverified",
        },
        addNote: {
          title: "Additional note",
        },
        issueConfirm: {
          title: "Issue has been confirmed and verified by {name}",
        },
      },
    },
    common: {
      count: "Search",
      returnTop: "Return to the top of results",
      back: "Back to quality dashboard",
      emptyHeader: "No quality listing result found.",
      emptySubHeader:
        "Try adjusting the filters to view your quality listing results.",
      errorMessage: {
        general: {
          // patch
          title: "Sorry, something went wrong.",
          prompt: "Please speak with your office administration.",
          button: "OK",
        },
        mandatoryImage: {
          // PHOTO_MANDATORY//patch /image only
          title: "You cannot remove all images",
          prompt: "Please keep one image to meet minimum requirement.",
          button: "OK",
        },
        issueResolvedByAgent: {
          // 404 from dashboard and also patch both
          title: "This issue has been resolved/updated by the agent",
          prompt: "This listing status is now updated in the dashboard",
          button: "Got it",
        },
        issueVerifiedByQM: {
          // patch QUALITY_ISSUE_IS_VERIFIED//both
          title: "This issue has been verified by another QC admin",
          prompt: "This listing status is now updated in the dashboard",
          button: "Got it",
        },
        issueFieldIsEmpty: {
          // patch ISSUE_VERIFIED_IS_EMPTY//image only
          title: "Verification is mandatory",
          prompt: "Please select at least one option",
          button: "Got it",
        },
        verificationError: {
          // patch ISSUE_VERIFIED_IS_EMPTY//image only
          title: "Verification error",
          prompt:
            "You are not allow to select a quality & non-quality option at the same time",
          button: "Got it",
        },
      },
    },
  },
};
